import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import AOS from "aos";
import "aos/dist/aos.css";

export const Partner = () => {
  useEffect(() => {
      AOS.init({
          duration: 1500,
          once: true,
          disable: function () {
              return window.innerWidth < 992;
          },
      });
  }, []);

    const options = {
    autoplayTimeout: 9000,
    smartSpeed: 1000,
    nav: false,
    loop: false,
    dots: true,
    autoplay: false,
    items: 1,
    margin: 0,
    autoHeight: false,
    stagePadding: 0,
    responsive: {
      0: {
        items: 2,
        autoHeight: true,
      },
      576: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  };
    return (
        <section className="wi_full py_3 partner_sec">
            <div className="container" data-aos="fade-in">
                <div className="sec_title text-center">
                    <h2>Our <span>Partners</span></h2>
                </div>
                <div className="carousel_wrapper mt-4">
                    <OwlCarousel className="partner" {...options}>
                        <div className="item"><img src="./images/partner-1.png" alt="Partner" /></div>
                        <div className="item"><img src="./images/partner-2.png" alt="Partner" /></div>
                        <div className="item"><img src="./images/partner-3.png" alt="Partner" /></div>
                        <div className="item"><img src="./images/partner-4.png" alt="Partner" /></div>
                        <div className="item"><img src="./images/partner-1.png" alt="Partner" /></div>
                        <div className="item"><img src="./images/partner-2.png" alt="Partner" /></div>
                        <div className="item"><img src="./images/partner-3.png" alt="Partner" /></div>
                        <div className="item"><img src="./images/partner-4.png" alt="Partner" /></div>
                    </OwlCarousel>
                </div>
            </div>
        </section>
    )
}